module.exports = __webpack_public_path__ + "img/shrewd-save-4.2eff6ac5.webp";